import { intersection } from 'lodash'
import { FIRM_ROLE, GROUP_ROLE, INTERNAL_ROLE } from '../router/roles.ts'

type Permissions = {
  firmRole: string[]
  groupRole: string[]
  deniedGroupRole: string[]
  internalRole: string[]
}

export const canCreateIdeaPermissions: Permissions = {
  firmRole: [FIRM_ROLE.ROLE_NORMAL],
  deniedGroupRole: [GROUP_ROLE.ROLE_MANAGER],
  groupRole: [GROUP_ROLE.ROLE_CAPTAIN, GROUP_ROLE.ROLE_CONTRIBUTOR],
  internalRole: [INTERNAL_ROLE.ROLE_NORMAL],
}

export const canSeeViewStatistics: Permissions = {
  firmRole: [FIRM_ROLE.ROLE_NORMAL, FIRM_ROLE.ROLE_COMPLIANCE],
  groupRole: [GROUP_ROLE.ROLE_CAPTAIN, GROUP_ROLE.ROLE_MANAGER],
  deniedGroupRole: [GROUP_ROLE.ROLE_CONTRIBUTOR],
  internalRole: [
    INTERNAL_ROLE.ROLE_MASTER,
    INTERNAL_ROLE.ROLE_ADMIN,
    INTERNAL_ROLE.ROLE_VIEWONLY,
    INTERNAL_ROLE.ROLE_MASTER,
  ],
}

export const canSeeFirmSelectPermissions: Permissions = {
  firmRole: [],
  groupRole: [],
  deniedGroupRole: [
    GROUP_ROLE.ROLE_CAPTAIN,
    GROUP_ROLE.ROLE_MANAGER,
    GROUP_ROLE.ROLE_CONTRIBUTOR,
  ],
  internalRole: [
    INTERNAL_ROLE.ROLE_MASTER,
    INTERNAL_ROLE.ROLE_ADMIN,
    INTERNAL_ROLE.ROLE_VIEWONLY,
  ],
}

export const canSeeCategorySelectPermissions: Permissions = {
  firmRole: [FIRM_ROLE.ROLE_COMPLIANCE, FIRM_ROLE.ROLE_NORMAL],
  groupRole: [GROUP_ROLE.ROLE_MANAGER],
  deniedGroupRole: [GROUP_ROLE.ROLE_CAPTAIN, GROUP_ROLE.ROLE_CONTRIBUTOR],
  internalRole: [
    INTERNAL_ROLE.ROLE_MASTER,
    INTERNAL_ROLE.ROLE_ADMIN,
    INTERNAL_ROLE.ROLE_VIEWONLY,
  ],
}

export const canSeeContributorSelectPermissions: Permissions = {
  firmRole: [FIRM_ROLE.ROLE_NORMAL, FIRM_ROLE.ROLE_COMPLIANCE],
  groupRole: [GROUP_ROLE.ROLE_CAPTAIN, GROUP_ROLE.ROLE_MANAGER],
  deniedGroupRole: [GROUP_ROLE.ROLE_CONTRIBUTOR],
  internalRole: [
    INTERNAL_ROLE.ROLE_MASTER,
    INTERNAL_ROLE.ROLE_ADMIN,
    INTERNAL_ROLE.ROLE_VIEWONLY,
  ],
}

export const canCreateUserPermissions: Permissions = {
  firmRole: [],
  deniedGroupRole: [],
  groupRole: [],
  internalRole: [INTERNAL_ROLE.ROLE_MASTER, INTERNAL_ROLE.ROLE_ADMIN],
}

export function hasPermission(
  permissions: Permissions,
  firmRole: string,
  groupRole: string,
  role: string
): boolean {
  const matchedAllowedFirmRoles = intersection(permissions.firmRole, [firmRole])
  const matchedAllowedGroupRoles = intersection(permissions.groupRole, [
    groupRole,
  ])
  const matchedDeniedGroupRoles = intersection(permissions.deniedGroupRole, [
    groupRole,
  ])
  const matchedAllowedInternalRoles = intersection(permissions.internalRole, [
    role,
  ])

  return (
    (matchedAllowedFirmRoles.length > 0 &&
      matchedAllowedGroupRoles.length > 0 &&
      matchedDeniedGroupRoles.length === 0) ||
    matchedAllowedInternalRoles.length > 0 ||
    matchedAllowedFirmRoles.includes('Compliance')
  )
}
